/* eslint-disable jsx-a11y/media-has-caption */
import React from 'react';
import { HeaderStyles } from './headerstyles';

export default function Header() {
  return (
    <HeaderStyles>
      <h3>Global fish stock sustainability</h3>
      <p>
        Share of assessed fish stocks classified as biologically sustainable in
        each FAO major fishing area in 2023. Select an ocean area to explore.
      </p>
    </HeaderStyles>
  );
}
